import React from 'react';
import { useParams } from 'react-router-dom';
import { Layout, Typography } from 'antd';

const { Content } = Layout;
const { Title } = Typography;

const Result = () => {
  const { id } = useParams();
  
  return (
    <Layout>
      <Content style={{ padding: '50px' }}>
        <Title level={2}>问诊结果</Title>
        <p>问诊ID: {id}</p>
        <p>结果页面正在开发中...</p>
      </Content>
    </Layout>
  );
};

export default Result; 